import React from 'react';
import PropTypes from 'prop-types';
import { Space } from '../../../../ds';
import LoaderBlue from './loader-blue.gif';
import './processingModal.scss';

const ProcessingModal = ({ title = '', message = '' }) => (
  <div className='processing-modal k-ds-width-full'>
    <Space justify='center' direction='vertical' align='center'>
      <img src={LoaderBlue} alt='loading...' />
    </Space>
    <Space
      className='k-ds-m-top-sp-03 k-ds-heading-05'
      direction='vertical'
      justify='center'
      align='center'
    >
      {title}
    </Space>
    <Space
      className='k-ds-body-02 k-ds-m-top-sp-04 k-ds-m-bottom-sp-06'
      justify='center'
    >
      <div className='processing-modal-message'>{message}</div>
    </Space>
  </div>
);

ProcessingModal.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
};

export default ProcessingModal;
